<!-- Banner -->
<div
  *ngIf="isExamPath() && showBanner"
  class="ml-4 my-2 bg-blue-50 border border-blue-300 p-6 relative"
  data-testid="banner"
>
  <button
    (click)="closeBanner()"
    class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-2xl font-bold"
    aria-label="Close banner"
    data-testid="close-banner"
  >
    ×
  </button>
  <div class="pr-8">
    If you are associated with a broker-dealer or investment adviser, please consult with your firm before submitting an
    exam enrollment request. Your firm may be required to submit a
    <a
      href="https://www.finra.org/registration-exams-ce/broker-dealers/registration-forms/form-u4"
      target="_blank"
      class="text-blue-600 underline hover:text-blue-800"
      data-testid="form-u4-link"
    >
      Form U4
    </a>
    to request an exam on your behalf.
  </div>
</div>

<div class="font-sans text-2xl font-semibold pl-4 pt-6">{{ dashboardTitle }}</div>
<div class="pl-4">
  <div class="grid gap-8 ml-4 lg:flex">
    <div class="flex flex-col self-baseline gap-8 md:flex-row lg:flex-col">
      <tess-quick-links [links]="quickLinks" class="row-span-3 md:flex-1 lg:w-[435px]" />
    </div>
  </div>
</div>
